import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import moment from "moment";
import ConnectionCard from "pages/connect/components/ConnectionCard";
import EventList from "pages/connect/components/EventList";
import FollowList from "pages/connect/components/FollowList";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import api from "services/api";

const ManageConnectionPage = ({ tab = "followers" }) => {
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [events, setEvents] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;

  useEffect(() => {
    loadData(tab);
    //console.log(tab);
  }, [url]);

  const loadData = async (type) => {
    try {
      if (type == "followers") {
        const userList = await api.social.followlist(type)
        setFollowers(userList?.data.list);
      } else if (type == "following") {
        const userList = await api.social.followlist(type)
        setFollowing(userList?.data.list);
      } else if (type == "collaborators") {
        const userList = await api.social.followlist(type)
        setCollaborators(userList?.data.list);
      } else if (type == "events") {
        retrieveEvents();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveEvents = async () => {
    let currentDate = moment();
    try {
      const temp = await api.calendar.listCalendars();
      const calendars = temp?.data?.calendars || [];
      let cids = calendars.map((x) => x.id);
      if (cids.length > 0) {
        const calendarEvents = await api.calendar.listEvents({
          "start_time[gte]": currentDate.startOf("day").toDate().toISOString(),
          order: "start_time",
          type: "task",
          calendar_id: cids.join(":"),
        });
        let raw = calendarEvents?.data?.events || [];
        setEvents(raw);
      }
    } catch (err) {
      console.log(err);
      toast.error(`Could not retrieve tasks!`);
    }
  };

  const TabComponent = {
    followers: (
      <FollowList
        tab={tab}
        datalist={followers}
        ContainerHeight={600}
      />
    ),
    following: (
      <FollowList
        tab={tab}
        datalist={following}
        ContainerHeight={600}
      />
    ),
    collaborators: (
      <FollowList
        tab={tab}
        datalist={collaborators}
        ContainerHeight={600}
      />
    ),
    events: (
      <EventList
        tab={tab}
        data={events}
        ContainerHeight={600}
        handleRefresh={retrieveEvents}
      />
    ),
  };

  return (
    <SuiBox sx={{ p: 3 }}>
      <SuiBox display="flex" gap={1}>
        <SuiBox sx={{ flexGrow: 0, minWidth: 260, width: 260, height: "100%" }}>
          <ConnectionCard />
        </SuiBox>
        <SuiBox sx={{ flexGrow: 1, mx: 2 }}>
          <SuiButton variant="text" color="dark" onClick={() => navigate(-1)} size="large">
            <ArrowBackIcon fontSize="sm" sx={{ mr: 0.5 }} /> Back
          </SuiButton>
          {TabComponent[tab]}
        </SuiBox>
      </SuiBox>
    </SuiBox>
  );
};

export default ManageConnectionPage;
